module.exports = __webpack_public_path__ + "static/media/dashboards&insights.26cd8816.svg";